var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "199.5 166.01 211.52 34.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill markers",
      fill: "rgb(87, 148, 248)"
    },
    d: "M 220.812 166.008 L 207.014 187.996 L 213.865 200 L 226.14 200 L 219.71 190.217 L 233.968 166.008 L 220.812 166.008 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(153, 155, 178)",
      stroke: "rgb(153, 155, 178)",
      strokeMiterlimit: 14,
      strokeOpacity: 0
    },
    d: "M 226.918 177.949 L 232.558 188.845 L 226.142 200 L 238.745 200 L 244.817 188.728 C 244.817 188.728 238.745 178.05 238.745 177.931 C 238.745 177.811 227.03 177.831 226.918 177.949 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(91, 145, 249)",
      fill: "rgb(91, 145, 249)"
    },
    d: "M 204.139 192.67 L 200 199.518 L 208.461 199.521 L 204.139 192.67 Z"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(153, 155, 178)",
      fontFamily: "Bahnschrift",
      fontSize: "10.6px",
      fontWeight: 700,
      whiteSpace: "pre"
    },
    transform: "matrix(1.759285, 0, 0, 1.601565, -48.643875, -30.904053)",
    x: 170.468,
    y: 141.066
  }, "BETTER TRUCKS"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo-name.87d12b01d21c27c84a4dfc8563bb9083.svg";
export { ForwardRef as ReactComponent };